import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import MuiList from '@mui/material/List';
import styled from '@mui/material/styles/styled';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ListItem from './ListItem';
import ProjectListItem from './ProjectListItem';
import SolrListItem from './SolrListItem';
import SolrNodeListItem from './SolrNodeListItem';
import { isLast, sentenceCase } from '../../../utils/utils';
import Text from '../../elements/text/Text';
import NoContent from '../../sections/no-content/NoContent';

const StyledBox = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(5, 0),
}));

const List = ({
  data,
  instance,
  isProjectList,
  isInstanceList,
  isSolrNodeList,
  onStartNode,
  onStopNode,
}) => {
  const { t } = useTranslation();
  const emptyProject = (
    <StyledBox sx={{ textAlign: 'center' }}>
      <Box sx={{ my: 2 }}>
        <Text titleLarge>
          {sentenceCase(
            t('empty', {
              ns: 'descriptions',
              text: t('project', { ns: 'project' }),
            })
          )}
        </Text>
      </Box>
      <Text>{t('createProjectFirst', { ns: 'descriptions' })}</Text>
      <Text>{t('waitForInvitation', { ns: 'descriptions' })}</Text>
    </StyledBox>
  );

  const emptyInstance = (
    <NoContent
      title={sentenceCase(
        t('empty', {
          ns: 'descriptions',
          text: t('instance', { ns: 'instance' }),
        })
      )}
    />
  );

  return (
    <MuiList>
      {data.length > 0 ? (
        data.map((item, i) => (
          <div key={i}>
            {isProjectList ? (
              <ProjectListItem project={item} />
            ) : isInstanceList ? (
              <SolrListItem instance={item} />
            ) : isSolrNodeList ? (
              <SolrNodeListItem
                instance={instance}
                solrNode={item}
                onStartNode={onStartNode}
                onStopNode={onStopNode}
              />
            ) : (
              <ListItem instance={item} />
            )}

            {!isLast(data, i) && <Divider />}
          </div>
        ))
      ) : (
        <>
          {isProjectList && emptyProject}
          {isInstanceList && emptyInstance}
        </>
      )}
    </MuiList>
  );
};

List.propTypes = {
  data: PropTypes.array.isRequired,
  instance: PropTypes.object,
  isProjectList: PropTypes.bool,
  isInstanceList: PropTypes.bool,
  isSolrNodeList: PropTypes.bool,
  onStartNode: PropTypes.func,
  onStopNode: PropTypes.func,
};

export default List;
